module.exports = __webpack_public_path__ + "img/antes_despues_09.50623a53.png";